import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Alert, Badge, Flex, List, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import isAfter from 'date-fns/isAfter';
import subDays from 'date-fns/subDays';
import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Refund() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const refund = (notifications || []).find(n => n.type === ENotificationType.REFUND);

  if (!refund?.quantity) return null;

  const refundExpiring = refund?.dueDates?.find(dueDates => {
    return isAfter(new Date(), subDays(new Date(dueDates.dueDate), 4));
  });

  return (
    <Link to='/producer/request-management'>
      <List.Item id='refund-notification-link'>
        <Flex vertical className='w-full' gap='small'>
          <Flex align='center' justify='space-between'>
            <Typography.Text strong>Reembolsos pendentes</Typography.Text>
            <Badge count={refund?.quantity || 0} showZero />
          </Flex>
          {refundExpiring && (
            <Alert
              showIcon
              icon={<Icon.Clock  />}
              type='error'
              message='Seu prazo de resposta para alguns reembolsos está se esgotando.'
            />
          )}
        </Flex>
      </List.Item>
    </Link>
  );
}
